import React, { useEffect, useState, useRef } from "react";
import {
  getUsageSubscriptions,

} from "../../requests";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { notifyError, notifySuccess } from "../helper/Toaster";

const Usage = () => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalCount, setTotalCount] = useState(0);

  const [drpName, setDrpName] = useState("");

  const timeoutRef = useRef(null);


  const getSubscriptionsData = async (pageVal) => {
    dispatch(startLoader());
    try {
      const response = await getUsageSubscriptions({
        page: pageVal,
        limit: limit,
        name: drpName,
      });
      if (response.status == 200) {
        setRows(response.data.data);
        setTotalCount(response.data.totalCount);
      }
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
      notifyError(error?.response?.data?.error || "Something went wrong");
    } finally {
      dispatch(stopLoader());
    }
  };


  useEffect(() => {
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set a new timeout to call the API after 1.5 seconds
    timeoutRef.current = setTimeout(() => {
      setPage(1);
      getSubscriptionsData(1);
    }, 1500);

    // Cleanup function to clear timeout on unmount or when filterData changes again
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [ drpName]);

  useEffect(() => {
    getSubscriptionsData(page);
  }, [page, limit]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <div className="overview-head">
        <div className="overview-head-left">Usage</div>
        <div className="overview-head-right">
          <input
            type="text"
            className="my-input"
            style={{ backgroundColor: "#E5E7EB" }}
            placeholder="Enter name"
            value={drpName}
            onChange={(e) => setDrpName(e.target.value)}
          />
         
        </div>
      </div>
      <div className="teacher-table" style={{ borderTop: "none" }}>
        <div className="teacher-table-head">
          <div className="teacher-table-head-cell" style={{ width: "10%" }}>
          S. No
        </div>
          <div className="teacher-table-head-cell" style={{ width: "30%" }}>
            Name
          </div>
          <div className="teacher-table-head-cell" style={{ width: "30%" }}>
            Email
          </div>
          <div className="teacher-table-head-cell" style={{ width: "30%",textAlign: "center"}}>
            Total Used Credits
          </div>
         
        </div>

        {rows.length === 0 && (
          <div
            style={{
              padding: "40px",
              textAlign: "center",
              color: "#9CA3AF",
            }}
          >
            No usage found
          </div>
        )}

        {rows.length > 0 &&
          rows.map((row, i) => {
            return (
              <div
                key={row.id}
                className="teacher-table-row"
                style={{
                  borderBottom: i === rows.length - 1 && "none",
                }}
              >
                <div className="teacher-table-row-cell" style={{ width: "10%" }}>
              {i + 1}
            </div>

                <div
                  className="teacher-table-row-cell"
                  style={{ width: "30%" }}
                >
                  {row.user_name}
                </div>

                <div
                  className="teacher-table-row-cell"
                  style={{ width: "30%" }}
                >
                  {row.user_email}
                </div>

                <div
                  className="teacher-table-row-cell"
                  style={{ width: "30%" ,textAlign: "center",fontWeight: "bold"}}
                >
               
                    {row.total_credits}
               
                </div>
              </div>
            );
          })}
      </div>
      <div className="di-flex" style={{ width: "100%" }}>
        <div style={{ color: "#6B7280" }}>
          {" "}
          Showing {(page - 1) * limit + 1} to {rows.length + (page - 1) * limit}{" "}
          out of {totalCount} items{" "}
        </div>
        <div className="di-flex" style={{ justifyContent: "end", gap: "10px" }}>
          <button
            disabled={page == 1}
            className="my-btn"
            style={{
              backgroundColor: "#E0F5FE",
              color: "#01A7DE",
              opacity: page == 1 ? 0.4 : 1,
            }}
            onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
          >
            Previous
          </button>
          <button
            disabled={rows.length + (page - 1) * limit >= totalCount}
            className="my-btn"
            style={{
              backgroundColor: "#E0F5FE",
              color: "#01A7DE",
              opacity: rows.length + (page - 1) * limit >= totalCount ? 0.4 : 1,
            }}
            onClick={() => setPage((p) => (rows.length ? p + 1 : p))}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Usage;
